const MONTH_NAMES_EN = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

/**
 * Appends English month names to a quarter months label.
 * e.g. "8-10" -> "8-10 [August - October]"
 */
export const formatMonthsLabelWithNames = (monthsLabel: string): string => {
  const months = monthsLabel.match(/\d{1,2}/g);
  if (!months || months.length < 2) return monthsLabel;
  const start = parseInt(months[0], 10);
  const end = parseInt(months[months.length - 1], 10);
  if (start < 1 || start > 12 || end < 1 || end > 12) return monthsLabel;
  return `${monthsLabel} [${MONTH_NAMES_EN[start - 1]} - ${MONTH_NAMES_EN[end - 1]}]`;
};
